import { clientSessionIdStore } from '@onramp/utils/clientSessionIdStore';

/**
 * True when the current partner's app id is on the remote
 * `sends-disabled-app-id-list`. An empty or missing list blocks nobody.
 *
 * Resolved on the server by the feature-flag middleware and hydrated onto the
 * page. The debug menu cannot override it.
 */
export function isSendOnlyDisabledForCurrentApp(): boolean {
  return clientSessionIdStore.getFeatureFlags()?.sendsDisabled === true;
}
